import _ from 'lodash';
import {
  RECEIVE_PROJECTS,
  PROJECT_HAS_BEEN_CREATED,
  PROJECT_HAS_BEEN_UPDATED,
  PROJECT_HAS_BEEN_DELETED
} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';

export default function project(state = initialState.project, action) {
  switch (action.type) {
    case RECEIVE_PROJECTS:
      return objectAssign({}, state, {
        items: action.items
      });
    case PROJECT_HAS_BEEN_CREATED:
      return objectAssign({}, state, {
        items: [
          ...state.items,
          action.newItem
        ]
      });
    case PROJECT_HAS_BEEN_UPDATED: {
      const idx = _.findIndex(state.items, (item) => {
        return item.key === action.updatedItem.key;
      });
      return objectAssign({}, state, {
        items: [
          ...state.items.slice(0, idx),
          action.updatedItem,
          ...state.items.slice(idx + 1)
        ]
      });
    }
    case PROJECT_HAS_BEEN_DELETED: {
      const idx = _.findIndex(state.items, (item) => {
        return item.key === action.deletedItem.key;
      });
      return objectAssign({}, state, {
        items: [
          ...state.items.slice(0, idx),
          ...state.items.slice(idx + 1)
        ]
      });
    }
    default:
      return state;
  }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/project.js
 **/